import { useCallback } from 'react';
import { useLocation } from 'react-router';
import useNavigate from './useNavigate';

function useRemoveHash() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    navigate(
      {
        hash: '',
        pathname: location.pathname,
        search: location.search,
      },
      { replace: true },
    );
  }, [navigate, location]);
}

export default useRemoveHash;
